// File: src/app/modules/components/monitor/monitor-routes/interfaces/work-progress-material.interface.ts

// Interfaz para el resultado final de materiales de trabajo en curso
export interface WorkProgressMaterialItem {
    // Información del material
    materialCode: string;
    materialName: string;
    
    // Información del cliente
    clientCode: string;
    clientName: string;
    
    // Información del documento
    documentNumber: string;
    documentClass: string;
    
    // Cantidades
    baseQuantity: number;
    parallelQuantity: number;
    total: number;

    // Información de lotes
    batches: BatchInfo[];
    hasBatches: boolean;
    batchCount: number;

    // Unidades de medida
    baseUnitOfMeasure: UnitOfMeasureInfo | null;
    parallelUnitOfMeasure: UnitOfMeasureInfo | null;
    
    // Referencias originales
    originalDocument: {
      id: string;
      serial: string;
      typeCode: string;
    };
    originalDetail: {
      id: string;
    };
  }
  
  // Interfaz para información de lotes
  export interface BatchInfo {
    batchNumber: string;
    quantity: number;
    expirationDate: string | null;
    manufacturingDate: string | null;
    status: string | null;
    warehouse: any; // TODO: Tipear cuando tengamos la estructura
    labels: LabelInfo[];
    parallelQuantity: number;
  }
  
  // Interfaz para la respuesta del servicio
  export interface WorkProgressMaterialsResponse {
    materials: WorkProgressMaterialItem[];
    totalItems: number;
    documentsProcessed: number;
    materialsWithBatches: number;
    totalBatches: number;
  }
  
  // Interfaces para la estructura del API (basado en el JSON proporcionado)
  export interface TripItem {
    _id: string;
    id: number;
    description: string;
    company: CompanyInfo;
    distributionChain: DistributionChainInfo;
    salesOffice: SalesOfficeInfo;
    routes: RouteInfo[];
    subRoute: SubRouteInfo;
    user: UserInfo;
    loadDateTime: string;
    dateHourStartTeoric: string;
    dateHourEndTeoric: string;
    numberOfActivities: any[]; // TODO: Tipear cuando sepamos la estructura
    numberOfFinalConsumer: number;
    numberOfEventualClient: number;
    vehicle: any; // TODO: Tipear cuando sepamos la estructura
    notifiedLiquidationToERP: boolean;
    isInventoryConfirmed: number;
    sendDocsToERPatClose: number;
    statusTripId: number;
    statusId: number;
    _deleted: boolean;
    __v: number;
    createdAt: string;
    updatedAt: string;
    externalKeys: ExternalKeys;
    totalWeight: WeightInfo;
    stops: string;
    visits: any[]; // TODO: Tipear cuando sepamos la estructura
    quantity: number;
  }
  
  export interface CompanyInfo {
    _id: string;
    id: number;
    name: string;
  }
  
  export interface DistributionChainInfo {
    _id: string;
    id: number;
    name: string;
  }
  
  export interface SalesOfficeInfo {
    _id: string;
    id: number;
    name: string;
  }
  
  export interface RouteInfo {
    _id: string;
    id: string;
    externalKeys: ExternalKeys;
    name: string;
  }
  
  export interface SubRouteInfo {
    _id: string;
    id: number;
    externalKeys: ExternalKeys;
    name: string;
    model: string;
    type: string;
    function: FunctionInfo;
  }
  
  export interface FunctionInfo {
    _id: string;
    code: string;
    name: string;
    statusId: number;
  }
  
  export interface UserInfo {
    _id: string;
    user_login: UserLoginInfo;
    business_partner_id: string;
    type: any; // TODO: Tipear cuando sepamos la estructura
  }
  
  export interface UserLoginInfo {
    _id: string;
    username: string;
    email: string;
  }
  
  export interface ExternalKeys {
    code: string;
    _id: string;
  }
  
  export interface WeightInfo {
    value: number;
    unit: string;
  }
  
  // Interfaces para documentos (basado en el JSON real proporcionado)
  export interface DocumentItem {
    _id: string;
    mobileCode: string;
    serial: string;
    documentRangeId: number;
    application: ApplicationInfo;
    subApplication: SubApplicationInfo;
    type: DocumentTypeInfo;
    class: DocumentClassInfo;
    sourceTransactions?: SourceTransactionInfo[];
    operationType: number;
    isDirectSale: boolean;
    hasExternalInvoice: boolean;
    company: CompanyInfo;
    distributionChain: DistributionChainInfo;
    salesOffice: SalesOfficeInfo;
    routes: RouteInfo[];
    subRoute: SubRouteInfo;
    responsibleBusinessPartner?: BusinessPartnerInfo;
    user: UserInfo;
    soldTo: BusinessPartnerInfo;
    shipTo: BusinessPartnerInfo;
    address: AddressInfo;
    currency: CurrencyInfo;
    paymentCondition: PaymentConditionInfo;
    creationDateTime: string;
    subTotal: number;
    totalDiscounts: number;
    totalSurcharges: number;
    subTotalBeforeTaxes: number;
    totalTaxes: number;
    total: number;
    preBalance: number;
    balance: number;
    isOrderTaxExempt: boolean;
    detail: DocumentDetailItem[];
    trip: TripInfo;
    isOrderWithoutStock: boolean;
    isUnified: any; // null en el ejemplo
    isInventoryConfirmed: number;
    statusERP: number;
    statusId: number;
    _deleted: boolean;
    createdBySession: UserLoginInfo;
    nextTransactions: any[];
    warehouses: any[];
    interlocutors: any[];
    taxes: any[];
    approvalUserLogins: any[];
    extraStatusERP: ExtraStatusERPInfo[];
    attachedFilePurchaseOrder: any[];
    createdAt: string;
    updatedAt: string;
    code: string;
    __v: number;
    externalKeys?: ExternalKeys;
    serialInvoice?: string;
    invoiceExternalkeys?: ExternalKeys;
  }
  
  export interface ApplicationInfo {
    _id: string;
    code: string;
    name: string;
    statusId: number;
  }
  
  export interface SubApplicationInfo {
    _id: string;
    code: string;
    name: string;
    description: string;
    type: string;
    application_id: string;
    isExternal: boolean;
    statusId: number;
    _deleted: boolean;
    createdAt: string;
    updatedAt: string;
  }
  
  export interface DocumentTypeInfo {
    _id: string;
    code: string;
    externalKeys: ExternalKeys;
    name: string;
    statusId: number;
  }
  
  export interface DocumentClassInfo {
    _id: string;
    code: string;
    externalKeys: ExternalKeys;
    name: string;
    keepsPricesOfSourceTransaction: boolean;
    makesStockReservation: boolean;
    canUpdatePrices: boolean;
    hasExternalInvoice: boolean;
    numberOfRequiredApprovals: number;
    statusId: number;
  }
  
  export interface SourceTransactionInfo {
    code: string;
    serial: string;
    type: {
      _id: string;
      code: string;
      name: string;
      statusId: number;
    };
    class: DocumentClassInfo;
  }
  
  export interface BusinessPartnerInfo {
    _id: string;
    id: number;
    externalKeys: ExternalKeys;
    name: string;
    types?: BusinessPartnerTypeInfo[];
    ownPriceList?: PriceListInfo;
  }
  
  export interface BusinessPartnerTypeInfo {
    _id: string;
    code: string;
    name: string;
    isEmployee: boolean;
    allowUserCreation: boolean;
    statusId: number;
  }
  
  export interface PriceListInfo {
    _id: string;
    code: string;
    name: string;
    statusId: number;
  }
  
  export interface AddressInfo {
    _id: string;
    externalKeys: ExternalKeys;
    type: AddressTypeInfo;
    name: string;
    locationOne: LocationInfo;
    locationTwo: LocationInfo;
    locationThree: LocationInfo;
    address: string;
    reference: string;
    geolocationPoint: any[]; // Array vacío en el ejemplo
    phones: PhoneInfo[];
    isPrincipal: boolean;
    emails: any[]; // Array vacío en el ejemplo
  }
  
  export interface AddressTypeInfo {
    _id: string;
    id: number;
    name: string;
    type: string;
    statusId: number;
    _deleted: boolean;
    createdAt: string;
    updatedAt: string;
  }
  
  export interface LocationInfo {
    _id: string;
    code: string;
    name: string;
    statusId: number;
  }
  
  export interface PhoneInfo {
    _id: string;
    type: {
      _id: string;
      id: number;
      type: string;
      statusId: number;
      _deleted: boolean;
      createdAt: string;
      updatedAt: string;
    };
    phone: string;
    isPrincipal: boolean;
    statusId: number;
  }
  
  export interface CurrencyInfo {
    _id: string;
    name: string;
    factor: number;
  }
  
  export interface PaymentConditionInfo {
    _id: string;
    id: number;
    externalKeys: ExternalKeys;
    name: string;
    daysToPay: number;
    type: string;
  }
  
  export interface TripInfo {
    _id: string;
    id: number;
    externalKeys: ExternalKeys;
    dateHourStartTeoric: string;
    dateHourEndTeoric: string;
    dateHourStart: string;
    dateHourEnd: string;
  }
  
  export interface ExtraStatusERPInfo {
    type: string;
    code: string;
    description: string;
    _id: string;
  }
  
  export interface DocumentDetailItem {
    _id: string;
    position: number;
    sourceTransaction?: {
      code: string;
      serial: string;
      type: {
        _id: string;
        code: string;
        name: string;
        statusId: number;
      };
      class: DocumentClassInfo;
      position: number;
    };
    material: MaterialInfo;
    baseOriginalQuantity: number;
    baseConversionFactor: number;
    baseQuantity: number;
    baseUnitOfMeasure: UnitOfMeasureInfo;
    pararellOriginalQuantity: number;
    pararellConversionFactor: number;
    pararellQuantity: number;
    pararellUnitOfMeasure: UnitOfMeasureInfo;
    soldOriginalQuantity: number;
    soldQuantity: number;
    soldQuantitySuggested: number;
    stockAtCreation: number;
    soldUnitOfMeasure: UnitOfMeasureInfo;
    batches: BatchDetailInfo[];
    deliveredQuantity: number;
    originalUnitPrice: number;
    unitPrice: number;
    priceConditionClasses: PriceConditionClassInfo[];
    hasMinimumAndMaximunPrices: boolean;
    hasScalePrices: boolean;
    isPromotion: boolean;
    taxes: TaxInfo[];
    subTotal: number;
    totalDiscounts: number;
    totalSurcharges: number;
    subTotalBeforeTaxes: number;
    totalTaxes: number;
    total: number;
    returnType: any; // null en el ejemplo
    statusERP: number;
    statusId: number;
    unifiedSourceTransactions: any[];
    deliveredBatches: any[];
    rejectedQuantitiesOnDelivery: any[];
    discounts: any[];
    surcharges: any[];
    evidences: any[];
    relatedDocuments: any[];
    createdAt: string;
    updatedAt: string;
  }
  
  export interface MaterialInfo {
    _id: string;
    code: string;
    externalKeys: ExternalKeys;
    name: string;
    UMPActive: boolean;
    batchControlActive: boolean;
    dimensions: MaterialDimensionsInfo;
    materialGroups: any[]; // Array vacío en el ejemplo
    materialImages: any[]; // Array vacío en el ejemplo
  }
  
  export interface MaterialDimensionsInfo {
    height: number;
    width: number;
    length: number;
    grossWeight: number;
    netWeight: number;
    weightUnitOfMeasureCode: string;
    volume: number;
    volumeUnitOfMeasureCode: string;
  }
  
  export interface UnitOfMeasureInfo {
    _id: string;
    code: string;
    name: string;
  }
  
  export interface BatchDetailInfo {
    bacth?: string; // Nota: en el API viene como "bacth" (typo), no "batch"
    batchNumber?: string;
    batch?: string;
    lote?: string;
    expirationDate?: string;
    fechaVencimiento?: string;
    quantity?: number;
    cantidad?: number;
    parallelQuantity?: number;
    manufacturingDate?: string;
    fechaFabricacion?: string;
    labels?: LabelInfo[];
    status?: string;
    estado?: string;
    warehouse?: any;
    almacen?: any;
  }
  
  export interface LabelInfo {
    label: string;
    quantity: number;
    parallelQuantity: number;
  }
  
  export interface PriceConditionClassInfo {
    code: string;
    value: string;
    _id: string;
  }
  
  export interface TaxInfo {
    code: string;
    name: string;
    taxBase: number;
    percentage: number;
    amount: number;
  }
  
  // Constantes para exportación
  export const WORK_PROGRESS_MATERIAL_EXPORT_ID = "work-progress-material-summary";
  export const WORK_PROGRESS_MATERIAL_TITLE = "Resumen de Materiales - Trabajo en Curso";
  
  export const WORK_PROGRESS_MATERIAL_PROPERTIES = {
    materialCode: "Código Material",
    materialName: "Nombre Material",
    clientCode: "Código Cliente", 
    clientName: "Cliente",
    documentNumber: "Nro Documento",
    documentClass: "Clase Documento",
    baseQuantity: "Cantidad UMB",
    baseUnitOfMeasure: "UM Base",
    parallelQuantity: "Cantidad UMP", 
    parallelUnitOfMeasure: "UM Paralela",
    total: "Precio Total",
    batchNumber: "Número de Lote",
    batchQuantity: "Cantidad Lote",
    manufacturingDate: "Fecha Fabricación",
    expirationDate: "Fecha Vencimiento",
    hasBatches: "Tiene Lotes",
    batchCount: "Cantidad de Lotes"
  };